import request from '@/config/axios'

export interface CircleOwnerVO {
  id?: number
  userId?: number
  avatar?: string
  realName?: string
  nickname?: string
  mobile?: string
  company?: string
  position?: string
  circleCount?: number
  circleNames?: string
  status?: number
  tierAmount?: number
  tradeOrderId?: number
  licenseUrl?: string
  venueImagesJson?: string
  officeAddress?: string
  applyRemark?: string
  rejectReason?: string
  paidTime?: string
  auditTime?: string
  passTime?: string
  createTime?: string
}

export const getCircleOwnerPage = (
  params: PageParam & {
    status?: number
    userId?: number
    nickname?: string
    keyword?: string
    roster?: boolean
  }
) => request.get({ url: '/bosscircle/circle/owner/page', params })

export const auditCircleOwner = (data: { id: number; pass: boolean; rejectReason?: string }) =>
  request.put({ url: '/bosscircle/circle/owner/audit', data })
